import * as R from 'ramda';

const isNaN = R.equals(NaN);
export const isNilOrEmpty = R.anyPass([R.isNil, R.isEmpty, isNaN]);

const actionResult = (actionType, payload = {}) => ({
  type: actionType,
  payload: R.defaultTo({}, payload),
});

export const createAction = (actionType) => (payload) => actionResult(actionType, payload);

export const createThunk = (actionType) => (payload) => (dispatch) =>
  Promise.resolve(dispatch(actionResult(actionType, payload)));

export const createReducer = (defaultState, actions) => {
  return (state = defaultState, action) => {
    const handler = actions[action.type];
    if (!handler) return state;

    return handler(state, action);
  };
};
